import { MediaPackGuide } from '@calm/evexia-web-sdk';
import { useMemo } from 'react';
import { useActiveCircle } from '../use-active-circle';
import { useMediaPackProgram } from '../use-media-pack-program';
import { useProgram } from '../use-program';

export function usePackGuideToProgramGuide(
    packGuide: MediaPackGuide | undefined,
    packClass: string,
    fetchPackProgram = true
) {
    const { activeCircleId } = useActiveCircle();
    const { program, isFetched: isProgramFetched } = useProgram(
        packGuide?.programId,
        packClass,
        activeCircleId
    );

    const { packProgram, isFetched: _isPackProgramFetched } =
        useMediaPackProgram({
            packClass: fetchPackProgram ? packClass : undefined,
            programId: packGuide?.programId,
        });
    const isPackProgramFetched = !fetchPackProgram || _isPackProgramFetched;

    const programGuide = useMemo(
        () => program?.guides.find(({ id }) => id === packGuide?.guideId),
        [packGuide?.guideId, program?.guides]
    );

    return {
        program,
        programGuide,
        isFetched: isPackProgramFetched && isProgramFetched,
        packProgram,
    };
}
